module.exports = __webpack_public_path__ + "static/about-us-e040cf85e1d36af4a5a05ce593f5466c.jpg";